var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15992 2.16659L2.99992 0.333252L3.83325 2.16659L5.66658 2.99992L3.83325 3.83992L2.99992 5.66658L2.15992 3.83992L0.333252 2.99992L2.15992 2.16659Z",
    fill: "#AF91FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65325 6.66658L8.33325 2.99992L9.99992 6.66658L13.6666 8.33325L9.99992 10.0133L8.33325 13.6666L6.65325 10.0133L2.99992 8.33325L6.65325 6.66658Z",
    fill: "#AF91FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerated);
export default __webpack_public_path__ + "static/media/generated.6538e08149a9a22a50109f9ae53d7c4c.svg";
export { ForwardRef as ReactComponent };